import { useEffect, useMemo, useRef, useState } from 'react'; // React 훅들 import
import { EQM1030_R01Dto } from './Dto_EQM1030_R01'; // EQM1030 데이터 타입 import
import { useEQM1030_R01Store } from './Store_EQM1030_R01'; // Zustand 스토어 훅 import

/**
 * ref02 값에 따라 색상 클래스를 반환하는 함수
 * - 'C' (설비온도): 초록색 계열
 * - 'D' (설비시간): 파란색 계열
 */
const getColorClasses = (ref02Value: string) => {
    const isGreen = ref02Value === 'C';
    return {
        /*
          headerBg: isGreen ? 'bg-green-900 text-white' : 'bg-blue-900 text-white',
        subHeaderBg: isGreen ? 'bg-green-900 text-white font-semibold' : 'bg-blue-900 text-white font-semibold',
        labelBg: isGreen ? 'bg-green-100' : 'bg-blue-100',
        settingLabelBg: isGreen ? 'bg-green-100' : 'bg-blue-150', // 설정 라벨 셀 배경색 (C는 초록, D는 파랑)
        currentLabelBg: isGreen ? 'bg-green-100' : 'bg-blue-150', // 현재 라벨 셀 배경색 (C는 초록, D는 파랑)
        settingDataBg: 'bg-amber-100', // 설정 행 데이터 셀은 라이트 베이지/오프화이트
        currentDataBg: 'bg-blue-50', // 현재 행 데이터 셀은 순수 흰색
        //  */
        // 메인 헤더: 그라데이션 + 매우 큰 그림자 + 강한 클래식 베벨 효과
        headerBg: isGreen 
            ? 'bg-[#a0deaf] text-black shadow-[inset_0_4px_8px_rgba(255,255,255,0.4),inset_5px_0_px_rgba(255,255,255,0.2),inset_0_3px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]' 
            : 'bg-[#4290cf] text-white shadow-[inset_0_4px_8px_rgba(255,255,255,0.4),inset_5px_0_18px_rgba(255,255,255,0.2),inset_0_px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]',

        // 서브헤더(구분, 컬럼헤더): headerBg 색상에 맞춘 밝은 톤 + 강한 광택 효과
        subHeaderBg: isGreen 
            ? 'bg-[#a0deaf] text-black font-semibold shadow-[inset_0_8px_16px_rgba(255,255,255,0.4),inset_5px_0_px_rgba(255,255,255,0.2),inset_0_3px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]' 
            : 'bg-[#4290cf] text-white font-semibold shadow-[inset_0_8px_16px_rgba(255,255,255,0.4),inset_5px_0_px_rgba(255,255,255,0.2),inset_0_3px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]',
        labelBg: isGreen ? 'bg-green-100' : 'bg-indigo-100',

        // 설정/현재 라벨: 더 진한 안쪽 그림자 + 테두리 + 강한 광택 효과
        settingLabelBg: isGreen 
            ? 'bg-green-100  shadow-[inset_0_8px_16px_rgba(255,255,255,0.4),inset_5px_0_px_rgba(255,255,255,0.2),inset_0_3px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]' 
            : 'bg-[#75a8d1] text-white shadow-[inset_0_8px_16px_rgba(255,255,255,0.4),inset_5px_0_px_rgba(255,255,255,0.2),inset_0_3px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]',
        currentLabelBg: isGreen 
            ? 'bg-green-100  shadow-[inset_0_8px_16px_rgba(255,255,255,0.4),inset_5px_0_px_rgba(255,255,255,0.2),inset_0_3px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]' 
            : 'bg-[#75a8d1] text-white shadow-[inset_0_8px_16px_rgba(255,255,255,0.4),inset_5px_px_rgba(255,255,255,0.2),inset_0_3px_0_rgba(255,255,255,0.35),inset_3px_0_0_rgba(255,255,255,0.3),inset_0_-6px_12px_rgba(0,0,0,0.4),inset_-4px_0_10px_rgba(0,0,0,0.4),inset_0_-2px_0_rgba(0,0,0,0.3),inset_-2px_0_0_rgba(0,0,0,0.3)]',

        // 데이터 셀: 설정/현재 라벨과 동일한 광택 효과
        settingDataBg: 'bg-amber-100 shadow-[inset_0_4px_5px_rgba(0,0,0,0.4),inset_5px_0_12px_rgba(0,0,0,0.2),inset_0_3px_0_rgba(0,0,0,0.35),inset_3px_0_0_rgba(0,0,0,0.3),inset_0_-6px_12px_rgba(255,255,255,0.4),inset_-4px_0_10px_rgba(255,255,255,0.4),inset_0_-2px_0_rgba(255,255,255,0.3),inset_-2px_0_0_rgba(255,255,255,0.3)]', // 설정 행 데이터 셀은 라이트 베이지/오프화이트
        currentDataBg: 'bg-indigo-50 shadow-[inset_0_4px_5px_rgba(0,0,0,0.4),inset_5px_0_12px_rgba(0,0,0,0.2),inset_0_3px_0_rgba(0,0,0,0.35),inset_3px_0_0_rgba(0,0,0,0.3),inset_0_-6px_12px_rgba(255,255,255,0.4),inset_-4px_0_10px_rgba(255,255,255,0.4),inset_0_-2px_0_rgba(255,255,255,0.3),inset_-2px_0_0_rgba(255,255,255,0.3)]', // 현재 행 데이터 셀은 순수 흰색
    };
};

/**
 * EQM1030 전용 매트릭스 뷰 컴포넌트
 * - 가로: itemGroupName
 * - 세로: 설정/현재 2행
 * - 컬럼이 많아질 경우 15개 단위로 페이지 분할
 */
export const Table_EQM1030_R01 = () => {
    const { EQM1030_R01List } = useEQM1030_R01Store(); // 스토어에서 데이터 리스트 가져오기
    const [page, setPage] = useState(0); // 현재 페이지 번호 상태
    // 컨테이너 너비에 맞춰 한 페이지에 표시할 컬럼 수 자동 계산
    const containerRef = useRef<HTMLDivElement>(null); // 컨테이너 DOM 참조용 ref
    const [colsPerBand, setColsPerBand] = useState<number>(9); // 한 밴드당 컬럼 수 상태 (고정 12)
    const [bandsPerPage, setBandsPerPage] = useState<number>(1); // 한 페이지당 밴드 수 상태 (초기값 1)
    const minColWidth = 140; // 각 항목 최소 폭(px) - 컬럼 너비 계산 시 사용
    const bandHeight = 72;   // 헤더 1행 + 본문 2행 대략 높이(px) - 밴드 높이 계산 시 사용

    useEffect(() => {
        // 컨테이너 크기에 따라 컬럼 수와 밴드 수를 자동 계산하는 함수
        const calc = () => {
            const width = containerRef.current?.clientWidth ?? 0; // 컨테이너 현재 너비 가져오기 (없으면 0)
            if (width <= 0) return; // 너비가 0 이하면 계산 중단
            const padding = 0; // 좌우 패딩/스크롤 보정값 (현재는 미사용)
            const available = Math.max(0, width - padding); // 사용 가능한 너비 계산 (최소 0)
            const nextCols = 9; // 컬럼 수 고정
            setColsPerBand(nextCols); // 고정된 컬럼 수 상태 업데이트

            const height = containerRef.current?.clientHeight ?? 0; // 컨테이너 현재 높이 가져오기 (없으면 0)
            if (height > 0) {
                // 상단 컨트롤/여백을 일부 보정하여 밴드 수 계산
                const headerReserve = 60; // 상태/버튼 영역 높이 (px)
                const availH = Math.max(0, height - headerReserve); // 사용 가능한 높이 계산 (헤더 영역 제외)
                const nextBands = Math.max(1, Math.floor(availH / bandHeight)); // 사용 가능한 높이로 한 페이지당 밴드 수 계산 (최소 1)
                setBandsPerPage(nextBands); // 계산된 밴드 수 상태 업데이트
            }
        };
        calc(); // 컴포넌트 마운트 시 즉시 계산 실행
        const onResize = () => calc(); // 윈도우 리사이즈 시 실행할 함수 정의
        window.addEventListener('resize', onResize); // 윈도우 리사이즈 이벤트 리스너 등록
        return () => window.removeEventListener('resize', onResize); // 컴포넌트 언마운트 시 리스너 제거
    }, []); // 빈 의존성 배열 - 컴포넌트 마운트 시 한 번만 실행

    // ref02 값별로 itemGroupName을 그룹화
    const ref02Groups = useMemo(() => {
        const groups = new Map<string, string[]>(); // ref02 값을 키로, itemGroupName 배열을 값으로 하는 맵 초기화
        for (const row of EQM1030_R01List) {
            const ref02 = (row as any)?.ref02 ?? ''; // ref02 값 가져오기 (없으면 빈 문자열)
            const itemGroupName = row.itemGroupName; // itemGroupName 가져오기
            if (!itemGroupName) continue; // itemGroupName이 없으면 건너뜀
            if (!groups.has(ref02)) {
                groups.set(ref02, []); // ref02 그룹이 없으면 빈 배열로 초기화
            }
            const groupItems = groups.get(ref02)!; // ref02 그룹의 itemGroupName 배열 가져오기
            if (!groupItems.includes(itemGroupName)) {
                groupItems.push(itemGroupName); // 중복되지 않은 itemGroupName만 추가
            }
        }
        // ref02 값별로 정렬된 그룹 배열 반환
        return Array.from(groups.entries()).sort((a, b) => a[0].localeCompare(b[0]));
    }, [EQM1030_R01List]); // EQM1030_R01List가 변경될 때만 재계산

    // 설정/현재 값을 빠르게 찾도록 맵 구성 (itemGroupName을 키로 사용)
    const valueMap = useMemo(() => {
        const map = new Map<string, { settingValue: string | null; currentValue: string | null }>(); // itemGroupName을 키로 하는 맵 초기화
        for (const row of EQM1030_R01List) {
            const key = row.itemGroupName; // 맵의 키로 사용할 itemGroupName
            if (!key) continue; // itemGroupName이 없으면 건너뜀
            const prev = map.get(key) || { settingValue: null, currentValue: null }; // 기존 값이 있으면 가져오고 없으면 기본값 사용
            map.set(key, {
                // 기존 값이 있으면 유지, 없으면 새 값 사용 (null 병합 연산자)
                settingValue: row.settingValue ?? prev.settingValue,
                currentValue: row.currentValue ?? prev.currentValue,
            });
        }
        return map; // 완성된 맵 반환
    }, [EQM1030_R01List]); // EQM1030_R01List가 변경될 때만 재계산

    // ref02 그룹들을 밴드 단위로 평탄화: 한 밴드는 한 줄짜리 표(헤더+설정+현재 3행, colsPerBand 개의 컬럼)
    const allBands = useMemo(() => {
        const bands: { ref02Value: string; cols: string[] }[] = [];
        for (const [ref02Value, itemNames] of ref02Groups) {
            for (let i = 0; i < itemNames.length; i += colsPerBand) {
                const cols = itemNames.slice(i, i + colsPerBand);
                if (cols.length > 0) bands.push({ ref02Value, cols });
            }
        }
        return bands;
    }, [ref02Groups, colsPerBand]);

    // 페이지네이션: 스크롤 없이 화면에 표시 가능한 밴드 수만큼만 렌더링
    const itemsPerPage = Math.max(1, bandsPerPage); // 한 페이지에 표시할 밴드 수
    const totalPages = Math.max(1, Math.ceil(allBands.length / itemsPerPage)); // 전체 페이지 수
    const start = page * itemsPerPage; // 현재 페이지 시작 인덱스
    const end = Math.min(allBands.length, start + itemsPerPage); // 현재 페이지 끝 인덱스
    const pageBands = allBands.slice(start, end); // 현재 페이지에 표시할 밴드들

    const goPrev = () => setPage(p => Math.max(0, p - 1)); // 이전 페이지로 이동 (0보다 작아지지 않도록)
    const goNext = () => setPage(p => Math.min(totalPages - 1, p + 1)); // 다음 페이지로 이동 (최대 페이지를 초과하지 않도록)

    return (
        // 메인 컨테이너: flex 세로 방향, 전체 높이/너비 사용, ref로 DOM 참조
        <div ref={containerRef} className="flex flex-col -gap-[1px] h-full w-full">
            {/* 페이지네이션 컨트롤 영역: 우측 정렬 */}
            <div className="flex items-end justify-end mb-1">
                {/* 페이지네이션 버튼 컨테이너 */}
                <div className="flex gap-2">
                    {/* 이전 페이지 버튼: 첫 페이지가 아닐 때만 표시 */}
                    {page > 0 && (
                        <button className="px-3 bg-gray-200 rounded" onClick={goPrev}>이전</button>
                    )}
                    {/* 다음 페이지 버튼: 마지막 페이지가 아닐 때만 표시 */}
                    {page < totalPages - 1 && (
                        <button className="px-3 bg-gray-200 rounded" onClick={goNext}>다음</button>
                    )}
                </div>
            </div>

            {/* 스크롤 없이 페이지 단위로 밴드 렌더링 */}
            <div className="border border-gray-300">
                {(() => {
                    // 같은 ref02Value가 연속되는 밴드를 하나의 그룹으로 묶어 한 테이블로 렌더링
                    const groups: { ref02Value: string; bands: typeof pageBands }[] = [];
                    for (const b of pageBands) {
                        const last = groups[groups.length - 1];
                        if (!last || last.ref02Value !== b.ref02Value) groups.push({ ref02Value: b.ref02Value, bands: [b] });
                        else last.bands.push(b);
                    }
                    const view = (s?: string | null) => {
                        const t = (s ?? '').toString().trim();
                        return t === '' ? '0' : t;
                    };
                    const labelWidthPercent = 5;
                    const totalLabelWidth = labelWidthPercent * 2;
                    return groups.map((group, gIdx) => {
                        const ref02Value = group.ref02Value;
                        const displayRef02 = ref02Value === 'C' ? '설비온도' : ref02Value === 'D' ? '설비시간' : ref02Value;
                        const rowSpan = group.bands.length * 3; // 그룹 내 모든 밴드 행 수(헤더/설정/현재)
                        const colorClasses = getColorClasses(ref02Value); // ref02 값에 따라 색상 클래스 가져오기
                        return (
                            <table key={`group-${start + gIdx}`} className="w-full border-collapse text-center bg-gray-100 text-base select-text" style={{ tableLayout: 'fixed' }}>
                                <tbody>
                                    {group.bands.map((band, idxInGroup) => {
                                        const displayCols: string[] = (() => {
                                            const arr = [...band.cols];
                                            for (let i = arr.length; i < colsPerBand; i += 1) arr.push(`__blank_${i}`);
                                            return arr;
                                        })();
                                        const colPercent = displayCols.length > 0 ? (100 - totalLabelWidth) / displayCols.length : 100;
                                        return (
                                            <>
                                                <tr key={`h-${gIdx}-${idxInGroup}`}>
                                                    {idxInGroup === 0 && (
                                                        <th rowSpan={rowSpan} className={`border border-gray-300 ${colorClasses.headerBg} text-3xl px-2 align-middle`} style={{ width: `${labelWidthPercent}%` }}>
                                                            {displayRef02}
                                                        </th>
                                                    )}
                                                    <th className={`border border-gray-300 ${colorClasses.subHeaderBg} font-semibold text-2xl px-2`} style={{ width: `${labelWidthPercent}%` }}>구분</th>
                                                    {displayCols.map((name) => {
                                                        const meta = EQM1030_R01List.find(v => v.itemGroupName === name);
                                                        const ref03 = meta?.ref03 ?? '';
                                                        const ref04 = meta?.ref04 ?? '';
                                                        const ref05 = meta?.ref05 ?? '';
                                                        const hasMeta = !!(ref03 || ref04 || ref05);
                                                        return (
                                                            <th key={name} className={`border border-gray-300 ${colorClasses.headerBg} px-5 text-center`} style={{ width: `${colPercent}%` }}>
                                                                {hasMeta ? (
                                                                    <div className="leading-tight ">
                                                                        <div className="font-bold text-2xl pt ">{ref03} {ref04} </div>
                                                                        {/* <div className="mt-0.5">{ref05 ? <span className="text-xs ml-5 align-baseline">{ref05}</span> : null}</div> */}
                                                                    </div>
                                                                ) : (
                                                                    name.startsWith('__blank_') ? '' : name
                                                                )}
                                                            </th>
                                                        );
                                                    })}
                                                </tr>
                                                <tr key={`s-${gIdx}-${idxInGroup}`}>
                                                    <td className={`border border-gray-300 ${colorClasses.settingLabelBg} font-semibold text-base`} style={{ width: `${labelWidthPercent}%` }}>설정</td>
                                                    {displayCols.map((name) => {
                                                        const v = valueMap.get(name);
                                                        return (
                                                            <td key={`setting-${gIdx}-${idxInGroup}-${name}`} className={`border border-gray-300 px-1 ${colorClasses.settingDataBg} font-bold text-2xl`} style={{ width: `${colPercent}%` }}>
                                                                {name.startsWith('__blank_') ? '' : view(v?.settingValue)}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                                <tr key={`c-${gIdx}-${idxInGroup}`}>
                                                    <td className={`border border-gray-300 ${colorClasses.currentLabelBg} font-semibold text-base`} style={{ width: `${labelWidthPercent}%` }}>현재</td>
                                                    {displayCols.map((name) => {
                                                        const v = valueMap.get(name);
                                                        return (
                                                            <td key={`current-${gIdx}-${idxInGroup}-${name}`} className={`border border-gray-300 px-1 ${colorClasses.currentDataBg} font-bold text-2xl`} style={{ width: `${colPercent}%` }}>
                                                                {name.startsWith('__blank_') ? '' : view(v?.currentValue)}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            </>
                                        );
                                    })}
                                </tbody>
                            </table>
                        );
                    });
                })()}
            </div>
        </div>
    );
};


